/**
 * Created by Languagenut on 10/09/2019.
 */


import React  from 'react';
import {Button, Row , Col} from 'react-bootstrap'
import GeneralTable from '../general_table.js';
import Translation from '../../store/internationalization-store.js'
import {ProductService} from '../../services';
import {ProductStore} from '../../store';
import Constants from '../../constants.js';
import LanguageSelect from '../language_select.js';
import ContentService from '../../services/content-service.js';
import Checkbox from '../checkbox.js'
import Comfirmation from '../popup/comfirmation_popup.js';
export default class Overview extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            import:false
        };
    }

    componentWillMount(){
        ProductStore.on(Constants.GET_LANGUAGES ,  ()=>{
            console.log(ProductStore.getLanguages())
        });
    }

    componentDidMount(){
        ProductService.getAllLanguages();
    }

    goTo()
    {
        window.location.hash = 'content/vocabulay'
    }

    onLanguageChange(language){
        ContentService.fetchModules(language.ietf).then(function(response){

            let modules = [];

            for(var i = 0 ; i < response.length; i ++)
            {
                if(response[i].learning_ietf == language.ietf) modules.push(response[i])
            }

            this.setState({
                data:modules,
                ietf:language.ietf
            })

        }.bind(this))
    }

    goto(uid){
        window.location.hash = 'content/vocabulay/edit/'+uid
    }

    publish(catalogUID){
        ContentService.publish(catalogUID).then(this.onLanguageChange.bind(this , this.state))
    }

    unPublish(catalogUID){
        ContentService.unPublish(catalogUID).then(this.onLanguageChange.bind(this , this.state))
    }

    closeDeleted(){
        this.setState({showDeleted:false});
    }

    deleteObject(){
        ContentService.setDeleted(this.state.deletedUid).then(function(){
            ContentService.fetchModules(this.state.ietf).then(function(response){

                let modules = [];

                for(var i = 0 ; i < response.length; i ++)
                {
                    if(response[i].learning_ietf == this.state.ietf) modules.push(response[i])
                }

                this.setState({
                    data:modules,
                    showDeleted:false
                })
            }.bind(this))
        }.bind(this))
    }

    render(){
        const columns = [{
                dataField: 'uid',
                text: Translation.get(14 , 'Name'),
                sort: true,
                align: "left",
                hidden:true,
            },{
                dataField: 'title',
                text: Translation.get(14 , 'Name'),
                sort: true,
                align: "left",
                hidden:true,
            },{
                dataField: 'title',
                text: Translation.get(14 , 'Name'),
                sort: true,
                align: "left",
                formatter:(cell , row)=>{
                    return <a onClick={this.goto.bind(this , row.catalog_uid)} class="hyperlink">{cell || 'No Name'}</a>;
                } 
            },{
                dataField: 'description',
                text: Translation.get(2203 , 'Description'),
                align: "left",
            },{
                dataField: 'state',
                text: Translation.get(12779, 'Visible to Students'),
                sort: true,
                align: "left",
                formatter:(cell , row)=>{

                    let _function = this.unPublish.bind(this , row.catalog_uid)
                    if(cell == 'PENDING')
                    {
                        _function = this.publish.bind(this , row.catalog_uid)
                    }

                    return <Checkbox onChange={_function} checked={cell == 'PUBLISHED'} />
                }
            },{
                dataField: 'delete',
                text: '',
                sort: true,
                align: "left",
                formatter:(cell , row)=>{
                    return <div onClick={function() {
                                    this.setState({showDeleted:true, deletedUid:row.uid});
                                }.bind(this)}><i class="fas fa-trash-alt"></i></div>;
                }
            },

        ]

        return <div>
            <Comfirmation body={Translation.get(2418 , 'Are you sure you wish to delete this content')} onSave={this.deleteObject.bind(this)} show={this.state.showDeleted} onHide={this.closeDeleted.bind(this)}/>
            <Row>
                <Col md={6}>
                    <div class="d-flex align-items-left">
                        <div class="p-2 report_title">
                            {Translation.get(12207 , 'Custom Content')}
                        </div>
                    </div>
                </Col>
            </Row>
               <GeneralTable secondary={<div style={{marginTop:"8px"}}><LanguageSelect singularOnly={true} returnValue={this.onLanguageChange.bind(this)} /></div>}columns={columns} data={this.state.data || []} hideDownload={true} component={<Button onClick={this.goTo}>{Translation.get(2209, 'Create New Vocab')}</Button>} />
            </div>
    }
}